import { lazy } from "react";
const PPFCalculator = lazy(() =>
  import("./../../resources/Calculators/PPF/PPFCalculator")
);
const TDSCalulator = lazy(() =>
  import("./../../resources/Calculators/TDS/TDSCalculator")
);
const PersonalITCalculator = lazy(() =>
  import("./../../resources/Calculators/personalIT/PersonalITCalculator")
);
const MortgageCaclculator = lazy(() =>
  import("./../../resources/Calculators/Mortgage/MortgageCalculator")
);
let calculators = [
  {
    name: "EMI",
    content: [
      `The Equated Monthly Instalments (EMI) calculator estimates monthly repayments for short term loans such as, bank overdrafts or personal loans and long-term loans such as for property or cars.   Alternatively, you can estimate the maximum loan quantum you can be eligible for if you know how much you can pay back on a monthly basis.  This will help you to plan out your monthly budget.`,
      <br />,
      `Input: Loan amount, Interest rate, Loan period OR Down payment, Monthly payment, Interest rate, Loan period.`,
      <br />,
      `Output: EMI OR Max Loan size.`,
    ],
    category: "Accounting",
    route: "resource/calculator/accounting/emi",
    component: null,
  },
  {
    name: "TDS",
    content: [
      `TDS  is Tax Deducted at Source.  It is the amount of money deducted from payment to an employee or for services rendered based on payee type, activity type that generates the earning and amount liable for TDS.`,
      <br />,
      `Input:  Payee Type, Availability of Valid PAN, IT filing status over last 3 years, Source of income and Amount liable for TDS.`,
      <br />,
      `Output: TDS, TDS threshold.`,
    ],
    category: "Income Tax",
    route: "resource/calculator/incomeTax/tds",
    component: TDSCalulator,
  },
  {
    name: "Personal Tax",
    content: [
      `Personal tax calculator lets you calculate the amount of income tax you should pay depending on the tax slab under which your income falls in.  Taxable incomes may be from different sources such as salary, rent earned on property, interest earned on savings, business gains etc. `,
      <br />,
      `Input: Personal details, type of tax payer, annual income from different income sources, deductions.`,
      <br />,
      `Output: Total income, tax payable, tax to income ratio.`,
    ],
    category: "Income Tax",
    route: "resource/calculator/incomeTax/personalIT",
    component: PersonalITCalculator,
  },
  {
    name: "Life Insurance",
    content: [
      `The calculator offers you several choices for estimating the amount of life insurance you need.  Choices include Desired income level upon retirement, Years of income to be replaced or Coverage based on number of years of salary to be replaced plus credit residual credit obligations to be met post-retirement.`,
      <br />,
      `Input: Current age, Required salary, Number of years of income to replace, Number of dependents, Nominal rate of return, Tax rate, Inflation rate, Residual credit obligations at retirement.`,
      <br />,
      `Output: Required life insurance amount.`,
    ],
    category: "Payroll",
    route: "/",
    component: null,
  },
  {
    name: "PPF",
    content: [
      `PPF refers to Public Provident Fund.   It is a periodic tax saving investment.   This calculator estimates the value of your investments over time, permissible withdrawals and eligibility for loans against PPF amounts.  You can even use it in case your periodic investments or interest rate estimate change over time.`,
      <br />,
      `Input: Investment period, Interest rate and Investment amount.`,
      <br />,
      `Output: Investment value, Permissible loan amount against PPF balance and Permissible withdrawal amount.`,
    ],
    category: "Payroll",
    route: "resource/calculator/payroll/ppf",
    component: PPFCalculator,
  },
  {
    name: "Mortgage",
    content: [
      `Mortgage Calculator estimates your scheduled payments for a given loan size and desired loan duration.  It also shows the breakdown of your house value in terms of mortgage balance and equity value.`,
      <br />,
      `Input: Loan amount, Tenure, Interest rate, Number of payments a year, Extra optional payments`,
      <br />,
      `Output: Scheduled mortgage payments, Equity component of your property value at any given time.`,
    ],
    category: "Payroll",
    route: "resource/calculator/accounting/mortgage",
    component: MortgageCaclculator,
  },
];

export default calculators;
